import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { PublicNameProgramFamilyShareUrl } from '../../../../../Types';
import InviteParticipantStore from '../../InviteParticipantModal/Store';
import LinkRow from './LinkRow';

interface Props {
  programFamilyShareUrls: PublicNameProgramFamilyShareUrl[];
  inviteParticipantStore: InviteParticipantStore;
}

function TableBody({ inviteParticipantStore, programFamilyShareUrls }: Props) {
  return fromEmpty(programFamilyShareUrls)
    .map((programFamilyShareUrls) => (
      <LinkRow
        programFamilyShareUrls={programFamilyShareUrls}
        inviteParticipantStore={inviteParticipantStore}
      />
    ))
    .getOrElse(() => (
      <tr className="bg-gray-50 text-center">
        <td colSpan={6} className="p-36 text-gray-500">
          <T kind="No Program Deep Links to display" />
        </td>
      </tr>
    ));
}

export default observer(TableBody);
